<template>
  <div>
    <h1 class="mb-1">{{ $t('message.credit.mortgageRent') }}</h1>
    <p class="mb-3">{{ $t('message.credit.mortgageRentText') }}</p>
    <mobialis-form-with-validation
      @onValidate="emitValidation"
      data-cy="creditMortgageForm"
      v-av-analytics-form-submit="{ elementText: $t('message.common.continue') }"
    >
      <mobialis-selection-input-with-validation
        rules="required"
        :label="$t('message.credit.application.askOwnershipType')"
        v-model="ownershipType"
        :placeHolder="$t('message.credit.application.chooseOwnershipType')"
        vid="ownershipType"
        :options="ownership"
        data-cy="ownershipType"
      ></mobialis-selection-input-with-validation>
      <mobialis-text-input-with-validation
        rules="required|max:25"
        :label="$t('message.credit.application.askMortgageCompany')"
        v-model="mortgageCompany"
        vid="mortgageCompany"
        :helper="isAVRDesktop || isAVREmbed ? $t('message.credit.application.askMortgageCompanyHelper') : null"
        data-cy="mortgageCompany"
      ></mobialis-text-input-with-validation>
      <mobialis-text-input-with-validation
        rules="required|max_value:9999"
        :label="$t('message.credit.application.askMonthlyPayment')"
        v-model="monthlyPayment"
        vid="monthlyPayment"
        mask-type="money"
        :readonly="hasMonthlyPayment"
        data-cy="monthlyPayment"
      ></mobialis-text-input-with-validation>
      <div ref="scrollingContainer" :class="{ 'scrolling-container': isTDPrequalEnabled }">
        <mobialis-check-box-with-validation
          rules="required:true"
          :label="TermsText"
          vid="tandc"
          id="tandc"
          data-cy="tAndC"
        ></mobialis-check-box-with-validation>
      </div>
      <mobialis-button type="submit" class="my-4" data-cy="submitMortgageForm">{{
        $t('message.common.send')
      }}</mobialis-button>
    </mobialis-form-with-validation>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { homeOwnershipMixin } from '@/mixins';

export default {
  name: 'MortgageForm',
  mixins: [homeOwnershipMixin],
  data() {
    return {
      ownershipType: '',
      mortgageCompany: '',
      monthlyPayment: '',
      hasMonthlyPayment: false,
    };
  },
  computed: {
    ...mapGetters('business', [
      'getBankList',
      'getBankStrips',
      'getBusinessName',
      'getThisIsAmerica',
      'isTDPrequalEnabled',
    ]),
    TermsText() {
      if (this.isTDPrequalEnabled) {
        return `${this.$t('message.credit.application.checkBoxLabelTD', { dealer: this.getBusinessName })}`;
      }
      return `${this.$t('message.credit.application.checkBoxLabelV2', { dealer: this.getBusinessName })}`;
    },
  },
  mounted() {
    this.ownershipType = this.$store.state.user.financeApplication.ownershipType;
    this.mortgageCompany = this.$store.state.user.financeApplication.mortgageCompany;
    this.monthlyPayment = this.$store.state.user.financeDetails.monthlyPayment;
    this.hasMonthlyPayment = !!this.$store.state.user.financeDetails.monthlyPayment;
  },
  methods: {
    async emitValidation(isValid) {
      if (!isValid) {
        // make sure the checkbox is in view
        this.$refs.scrollingContainer.scrollTop = 0;
        return;
      }
      this.$store.commit('SET_LOADING', true);
      this.$store.commit('user/SET_OWNERSHIP_TYPE', this.ownershipType);
      this.$store.commit('user/SET_MORTGAGE_COMPANY', this.mortgageCompany);
      this.$store.commit('user/SET_MONTHLY_PAYMENT', this.monthlyPayment);
      this.$router.push({ name: `thank-you-${this.baseRoute}` });
    },
  },
};
</script>

<style lang="scss" scoped>
h1 {
  font-size: 28px;
  font-weight: bold;
}
.label {
  font-size: 16px;
  font-weight: 500;
}

// Scrolling text box for TD only
.scrolling-container {
  padding: 5px 15px 10px 5px;
  margin-right: 40px;
  max-height: 225px;
  margin-bottom: 10px;
  overflow: auto;
}
.form-check::v-deep {
  margin-top: 5px;
  label.form-check-label {
    p {
      margin-top: 0;
      margin-bottom: 7px;
    }
    ul,
    ol {
      padding-left: 25px;
    }
    p,
    ul,
    li,
    ol {
      color: #4b5863;
      font-size: 12px;
      line-height: 18px;
    }
  }
}
</style>
